<div class="step-container columns is-desktop">
  <app-aside-bar [statement]="statement" [workFlowController]="workFlowController"></app-aside-bar>

  <div class="send-certificate">
    <h1 class="title_42">{{ "SEND_CERTIFICATE.PAGE_TITLE" | translate }}</h1>
    <div class="inputs-wrapper">
      <app-file-input
        (fileChange)="handleFileSelected($event)"
        [labelText]="'SEND_CERTIFICATE.FILE_INPUT.LABEL'"
      ></app-file-input>
      <app-password-input
        [password]="password"
        (passwordChange)="handleSetPassword($event)"
        [(isValidated)]="isPasswordValidated"
        [isSimplePassword]="true"
        [errors]="errors"
      >
      </app-password-input>
    </div>
  </div>

  <app-tools-bar [statement]="statement" [buttons]="buttons"></app-tools-bar>
</div>
